// @flow

import { flatMap, compact, uniq, first } from 'lodash';
import React from 'react';

import NavLink from 'src/components/NavLink/NavLink';
import { Text, TextLink } from 'seek-style-guide/react';

import styles from './CompanyResults.less';

type Props = {
  clearCompanyRefinements: SearchParams,
  jobs: Array<SearchResultJob>
};

const renderClearCompanySearchLink = (
  clearCompanyRefinements: SearchParams
) => {
  // Note, that although the link says 'Show all Jobs', it's not meant
  // to show all jobs. It's only meant to clear the company search.
  // See discussion at https://github.com/SEEK-Jobs/chalice/issues/1568

  return (
    <NavLink
      children="Show all Jobs"
      className={styles.showAll}
      component={TextLink}
      data-automation="companyResultsClicked"
      location={{ pathname: '/jobs', query: clearCompanyRefinements }}
      rel="nofollow"
    />
  );
};

const renderCompanyMessage = (jobs: Array<SearchResultJob>) => {
  const uniqCompanyNames: Array<string> = uniq(
    compact(flatMap(jobs, 'advertiser.description'))
  );
  const companyNameCount: number = uniqCompanyNames.length;
  const isSingleCompany: boolean = companyNameCount === 1;
  const companyWord: string = isSingleCompany ? 'company' : 'companies';

  return (
    <span data-automation="companyName">
      {`Showing jobs for ${
        isSingleCompany
          ? first(uniqCompanyNames)
          : `${companyNameCount} ${companyWord}`
      }. `}
    </span>
  );
};

const CompanyResults = ({ jobs, clearCompanyRefinements }: Props) => (
  <Text
    baseline={false}
    raw
    small
    className={styles.root}
    data-automation="companyResults"
  >
    {renderCompanyMessage(jobs)}
    {renderClearCompanySearchLink(clearCompanyRefinements)}
  </Text>
);

export default CompanyResults;
